/* ED General Question form -> Klaviyo "General Question Submitted" event. */
(function () {
  var form = document.getElementById('gq-form');
  if (!form) return;
  var KEY = form.getAttribute('data-klaviyo') || 'QSdBG5';
  var HEAD = { 'Content-Type': 'application/vnd.api+json', 'accept': 'application/vnd.api+json', 'revision': '2024-10-15' };
  var btn = document.getElementById('gq-btn');
  var err = document.getElementById('gq-error');
  var loadedAt = Date.now();
  var labels = { 'gq-fname': 'First name', 'gq-lname': 'Last name', 'gq-email': 'Email', 'gq-phone': 'Phone', 'gq-topic': "What's this about?", 'gq-message': 'Your message' };

  function v(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function kl(path, payload) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KEY, { method: 'POST', headers: HEAD, body: JSON.stringify({ data: payload }) })
      .then(function (r) { return r.ok; }).catch(function () { return false; });
  }
  function showError(html, focusEl) {
    err.innerHTML = html; err.style.display = 'block';
    (focusEl || err).focus();
  }
  function done() {
    document.getElementById('gq-done-name').textContent = v('gq-fname') || 'friend';
    form.hidden = true; form.style.display = 'none';
    var d = document.getElementById('gq-done'); d.hidden = false;
    var t = document.getElementById('gq-done-title'); try { t.focus({ preventScroll: false }); } catch (e) { t.focus(); }
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (btn.disabled) return;
    err.style.display = 'none';
    var missing = [], first = null;
    Object.keys(labels).forEach(function (id) {
      var el = document.getElementById(id); el.removeAttribute('aria-invalid');
      if (!el.value.trim()) { missing.push(labels[id]); el.setAttribute('aria-invalid', 'true'); if (!first) first = el; }
    });
    var em = document.getElementById('gq-email');
    if (em.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) { missing.push('a valid email address'); em.setAttribute('aria-invalid', 'true'); if (!first) first = em; }
    var ph = document.getElementById('gq-phone');
    if (ph.value.trim() && ph.value.replace(/\D/g, '').length < 10) { missing.push('a valid phone number (10 digits)'); ph.setAttribute('aria-invalid', 'true'); if (!first) first = ph; }
    if (missing.length) { showError('Please fill in: ' + missing.join(', ') + '.'); return; }

    /* Spam guard: honeypot filled, or submitted under 3 seconds after load. Show success, send nothing. */
    if (v('gq-website') || (Date.now() - loadedAt) < 3000) { done(); return; }

    var fname = v('gq-fname'), lname = v('gq-lname'), full = fname + ' ' + lname;
    var p = {
      gq_name: full, gq_first_name: fname, gq_last_name: lname, gq_phone: v('gq-phone'), gq_topic: v('gq-topic'), gq_message: v('gq-message'),
      gq_source: 'Contact page general question form', gq_page: location.href.split('#')[0]
    };
    var email = v('gq-email');
    btn.disabled = true; btn.textContent = 'Sending...';
    kl('profiles', { type: 'profile', attributes: { email: email, first_name: fname, last_name: lname } })
      .then(function () {
        return kl('events', { type: 'event', attributes: { properties: p, metric: { data: { type: 'metric', attributes: { name: 'General Question Submitted' } } }, profile: { data: { type: 'profile', attributes: { email: email } } } } });
      })
      .then(function (sent) {
        if (!sent) {
          btn.disabled = false; btn.textContent = 'Send Message';
          showError('Something went wrong sending your message. Please try again, call <a href="tel:+19725202268">972-520-2268</a>, or email <a href="mailto:info@embedded-designz.com">info@embedded-designz.com</a>.');
          return;
        }
        done();
      });
  });
})();
